import actionTypes from "../actionTypes/submissions";

export const setSubmissions = (payload) => ({
  payload,
  type: actionTypes.SET_SUBMISSION,
});
